import React from 'react';
import PropTypes from 'prop-types';
import PlayerDuelDataContainer from '../PlayerDuel/containers/PlayerDuelDataContainer';
import PlayerListDataContainer from '../PlayerList/containers/PlayerListDataContainer';
import { MatchupWrapper } from './Matchup.style';

const Matchup = ({
    inningState,
    abstractGameCode,
    isWarmup,
    isSuspended,
    isCancelled,
    isPostponed,
    showUpcomingBatters = true,
    gameStateOverride,
    teams,
    currentInning,
    scheduledInnings,
    tiebreakerScenario
}) => {
    let MatchupUI;
    if (gameStateOverride !== '' && typeof gameStateOverride !== 'undefined') {
        MatchupUI = <PlayerDuelDataContainer showUpcomingBatters={showUpcomingBatters} gameStateOverride={gameStateOverride} />;
    } else {
        if (abstractGameCode === 'P') {
            MatchupUI = <PlayerDuelDataContainer showUpcomingBatters={showUpcomingBatters} />;
        } else if (abstractGameCode === 'L') {
            if (isWarmup) {
                MatchupUI = <PlayerDuelDataContainer showUpcomingBatters={showUpcomingBatters} />;
            } else if (isSuspended) {
                MatchupUI = null;
            } else if (inningState === 'End' || inningState === 'Middle') {
                const isAtFinalOrExtraInnings = currentInning >= scheduledInnings;
                if (!isAtFinalOrExtraInnings) {
            		MatchupUI = <PlayerListDataContainer />;
            	} else {
                    if (
                        (inningState === 'End' && ((teams.home.runs < teams.away.runs) && !tiebreakerScenario)) ||
                        (inningState === 'Middle' && (teams.home.runs > teams.away.runs))
                    ) {
                        MatchupUI = <PlayerDuelDataContainer showUpcomingBatters={false} usePreviousPlayers={true} />;
                    } else {
                        MatchupUI = <PlayerListDataContainer />;
                    }
                }
            } else {
                MatchupUI = <PlayerDuelDataContainer showUpcomingBatters={showUpcomingBatters} />;
            }
        } else {
            if (isCancelled || isPostponed) {
                MatchupUI = null;
            } else {
                MatchupUI = <PlayerDuelDataContainer showUpcomingBatters={false} />;
            }
        }
    }
    return (
        <MatchupWrapper>
            { MatchupUI }
        </MatchupWrapper>
    );
};

Matchup.propTypes = {
    inningState: PropTypes.string,
    abstractGameCode: PropTypes.string,
    isWarmup: PropTypes.bool,
    isSuspended: PropTypes.bool,
    isCancelled: PropTypes.bool,
    isPostponed: PropTypes.bool,
    gameStateOverride: PropTypes.string,
    tiebreakerScenario: PropTypes.object,
    showUpcomingBatters: PropTypes.bool,
    currentInning: PropTypes.number,
    scheduledInnings: PropTypes.number,
    teams: PropTypes.object
};

export default Matchup;
